import { render, staticRenderFns } from "./TsBranchFilters.vue?vue&type=template&id=615bd41e&scoped=true&"
import script from "./TsBranchFilters.vue?vue&type=script&lang=js&"
export * from "./TsBranchFilters.vue?vue&type=script&lang=js&"
import style0 from "./TsBranchFilters.vue?vue&type=style&index=0&id=615bd41e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615bd41e",
  null
  
)

export default component.exports